import { createRouter, createWebHistory } from 'vue-router'

import NavView from '@/views/NavView.vue'

import AttractPage from '@/views/AttractPage.vue'
import HomePage from '@/views/HomePage.vue'
import FullAlbumPage from '@/views/FullAlbumPage.vue'
import GuidedTourPage from '@/views/GuidedTourPage.vue'

import useInteraction from '@/composables/interaction'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'attract',
      component: AttractPage
    },
    {
      path: '/:page(.*)*',
      component: NavView,
      children: [
        {
          path: 'home',
          name: 'home',
          component: HomePage
        },
        {
          path: 'full-album',
          name: 'fullAlbum',
          component: FullAlbumPage
        },
        {
          path: 'guided-tour/:theme',
          name: 'guidedTour',
          component: GuidedTourPage
        }
      ]
    }
  ]
})

router.beforeEach((to) => {
  if (to.name !== 'attract') {
    useInteraction('page_view')
  }
})


export default router
